module.exports = "<div md-whiteframe=\"1\" class=\"content-box text-center\">\n  <h1>{{ \"USERS.CLIENT_ACTIVATION_RETRY.TITLE\" | translate }}</h1>\n  <p>{{ \"USERS.CLIENT_ACTIVATION_RETRY.INFO\" | translate }}</p>\n  <p>{{ \"USERS.CLIENT_ACTIVATION_RETRY.REPORT_PROBLEM\" | translate }}</p>\n  <p><a ui-sref=\"public.users.login\">{{ \"USERS.CLIENT_ACTIVATION_RETRY.GO_TO_LOGIN\" | translate }}</a></p>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/users/client/client-activation-retry.html
// module id = 234
// module chunks = 0